export const MuiOutlinedInput = {
  styleOverrides: {
    root: ({ theme }: any) => {
      return {
        color: theme?.palette?.grey["700"],
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: theme?.palette?.primary?.main,
        },
        borderRadius: "6px",
      };
    },

    input: (theme: any) => ({
      "&::placeholder": {
        color: `${theme?.palette?.grey["400"]} !important`,
        fontSize: "1.1rem",
      },
    }),
  },
};
